import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { Box, Grid2 as Grid, Stack } from "@mui/material"
import { importersForFields } from "routes/asset-register/plugins/excel-import/controller/importers-for-fields"
import { emptyArray } from "lib/empty-array"
import { Repeat } from "lib/@components/repeat"
import { importerAssetFields } from "../regime-display/asset-fields.mjs"
import { Bound } from "lib/@components/binding/Bound"
import { useRefresh } from "lib/@hooks/useRefresh"
import { useEffect } from "react"
import { MapFieldsAlert } from "./map-fields-alert"
import { ChooseMapping } from "./choose-mapping"
import { FieldSelector } from "./field-selector"
import {
    ExtendedSelectErrorChecker,
    ExtendedSelectNoOptions,
    ExtendedSelectNoOptionsValue,
    ExtendedSelectTop,
} from "slot-definitions"
import { FixedValueOption } from "./plugins/fixed-value-option/fixed-value-option"
import { UniqueFieldError } from "./plugins/unique-field-error/unique-field-error.runtime"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { CreateUniqueValue } from "routes/asset-register/plugins/excel-import/create-unique-value"
import { CreateUniqueValueEditor } from "routes/asset-register/plugins/excel-import/create-unique-value-editor"

export function MapFields({ canContinue }) {
    const [headers] = useBoundValue("headers", [])
    const [, setTemplateNames] = useBoundValue("templateNames", [])
    const [uniqueValues] = useBoundValue("uniqueValues")
    const [interpretedSheet] = useBoundValue("interpretedSheet")
    const [typeField] = useBoundValue("fields.type", emptyArray)
    const [tagField] = useBoundValue("fields.tag")

    const refresh = useRefresh()

    const existingMappings = importersForFields.useResults(headers.map("name").filter(Boolean)) ?? emptyArray

    const fields = importerAssetFields.filter((f) => !f.notInAssetImport).sortBy([(c) => c.importance || 9, "field"])

    const tagFieldName = tagField?.name

    const tagIsUnique =
        tagField === "*UNIQUE" ||
        (tagFieldName &&
            uniqueValues?.[tagFieldName] &&
            Object.keys(uniqueValues[tagFieldName]).length === interpretedSheet.length)

    useEffect(() => {
        canContinue(!!typeField?.length && !!tagField && tagIsUnique)
    }, [typeField, tagField, uniqueValues, interpretedSheet, canContinue, existingMappings, tagIsUnique])

    useEffect(() => {
        setTemplateNames(existingMappings.map("name"))
    }, [existingMappings, setTemplateNames])

    ExtendedSelectTop.usePlug(<FixedValueOption />)
    ExtendedSelectErrorChecker.usePlug(<UniqueFieldError />)
    ExtendedSelectNoOptions.usePlug(replaceAllWith(<CreateUniqueValue />))
    ExtendedSelectNoOptionsValue.usePlug(replaceAllWith(<CreateUniqueValueEditor />))

    return (
        <Bound refresh={refresh}>
            <Stack spacing={3} sx={{ mb: 1 }}>
                <ChooseMapping mappings={existingMappings} />
                <MapFieldsAlert />
                <Box>
                    <Grid container spacing={2} alignItems="stretch" sx={{ mt: 1 }}>
                        <Repeat list={fields} item={<FieldSelector />} />
                    </Grid>
                </Box>
            </Stack>
        </Bound>
    )
}
